var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"dropdown-list",attrs:{"items":_vm.GetAllRanks,"label":_vm.$t('SelectRank'),"outlined":"","dense":""},on:{"change":_vm.ChangeDropDown},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }